export type LegalTheme = 'light' | 'dark';

interface LegalThemeToggleProps {
  theme: LegalTheme;
  onToggle: () => void;
}

/**
 * Light/dark toggle for the legal document panel. React port of the inline
 * theme-toggle in the old public/shared/document.js. Scoped to legal pages
 * only (per Ellis 2026-05-31) — it themes the .legal-doc wrapper, not the site.
 */
export function LegalThemeToggle({ theme, onToggle }: LegalThemeToggleProps) {
  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <button
      type="button"
      className="legal-theme-toggle"
      onClick={onToggle}
      aria-label={`Switch to ${next} theme`}
    >
      <span className="legal-theme-toggle-icon" aria-hidden>
        {theme === 'dark' ? '☀' : '☾'}
      </span>
      <span>{theme === 'dark' ? 'Light' : 'Dark'}</span>
    </button>
  );
}
